import BaseService from "./BaseService";

export default {
    index() {
        return BaseService.get('/user/accounts');
    },
    createAccount(data) {
        return BaseService.post('/accounts', data);
    },
    updateAccount(id, data) {
        return BaseService.put('/accounts/' + id, data);
    },
    deleteAccount(id) {
        return BaseService.delete('/accounts/' + id);
    },
    addUserToAccount(data) {
        return BaseService.post('/user/accounts/', data);
    },
    deleteUserFromAccount(id) {
        return BaseService.delete('/user/accounts/' + id);
    }
}